import { render } from "./Range.vue?vue&type=template&id=8dd7fe62"
import script from "./Range.vue?vue&type=script&lang=js"
export * from "./Range.vue?vue&type=script&lang=js"

import exportComponent from "/Users/akosipau/Dropbox/Sites/onboarding/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__